module.exports = __webpack_public_path__ + "img/person-add-outline.png";